import { executeGetRequest } from "@api/client";
import { apiPath } from "@routes/api";

export const getEvents = async (lang: string) => {
  const [promise] = executeGetRequest(apiPath.events, lang);
  const result: any = await promise;
  return result.data;
};
